import reset from "../utils/reset_events.js";
class Tabs {
    constructor(tablist) {
        this.tablist = tablist;

        this.init();
    }

    init() {
        this.tabs();
        this.switch_tabs();
    }

    switch_tabs() {
        const parrotButtons = document.querySelectorAll("[data-parrot]");
        parrotButtons.forEach((button) => {
            button.addEventListener("click", (e) => this.changeTabs(e));
        });
    }

    changeTabs(e) {
        const parrot = e.currentTarget.dataset.parrot;
        const target = parrot
            ? document.querySelector(e.currentTarget.dataset.parrot)
            : e.currentTarget;
        const parent = target.parentNode;
        const id = target.getAttribute("aria-controls");
        const buttons = parent.querySelectorAll("[aria-controls]");

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => t.setAttribute("aria-selected", "false"));

        // Set this tab as selected
        target.setAttribute("aria-selected", "true");

        // Hide all related tab panels
        buttons.forEach((button) => {
            document
                .getElementById(button.getAttribute("aria-controls"))
                .setAttribute("aria-hidden", "true");
        });

        // Show the selected panel
        this.open_panel = document.querySelector(`#${id}`);
        this.open_panel.setAttribute("aria-hidden", "false");

        if (parrot) {
            document.querySelector(".tabs").scrollIntoView(true);
        }

        // Check that event is triggered by user and not addEventListener
        if (e.isTrusted) this.reset_events();
    }

    tabs() {
        const tabs = this.tablist.querySelectorAll('[role="tab"]');

        if (!tabs.length) return;

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", this.changeTabs.bind(this));
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        this.tablist.addEventListener("keydown", (e) => {
            // Move right
            if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowRight") {
                    tabFocus++;
                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.key === "ArrowLeft") {
                    tabFocus--;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }

                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });

        this.selected_tab();
    }

    selected_tab() {
        let hash = location.hash.length
            ? location.hash.replace("#", "").concat("-content")
            : sessionStorage.getItem("selected_tab");

        if (hash && document.getElementById(hash)) {
            let button = this.tablist.querySelector(
                `[aria-controls="${hash}"]`,
            );
            if (button && !button.dataset.parrot) {
                button.dispatchEvent(new Event("click", { bubbles: true }));
            }
        }

        window.onpagehide = (e) => {
            let button = document.querySelector(
                '.main-tabs[aria-selected="true"]',
            );
            if (button && !button.dataset.parrot) {
                let hash = button.getAttribute("aria-controls");
                sessionStorage.setItem("selected_tab", hash);
            }
        };
    }

    reset_events() {
        reset.refreshCarousels(this.open_panel);
        reset.refreshDialogs(this.open_panel);
        reset.refreshAccordions(this.open_panel);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const tablists = document.querySelectorAll("[role='tablist']");

    if (tablists) {
        tablists.forEach((tablist) => {
            new Tabs(tablist);
        });
    }
});
